module.exports = __webpack_public_path__ + "static/media/extension-logo.32438c0f.svg";